import React from 'react';
import IntroductionWrapper from '../layout/IntroductionWrapper';
import { Details } from '../Details';
import { faq } from '../../calculations/faq';

/**
 * Specialized component for rendering FAQ section
 * Handles FAQ data processing and display
 */
const FAQDisplay = ({ faqs, title = 'FAQs' }) => {
  if (!faqs) return null;

  return (
    <IntroductionWrapper>
      <h3>{title}</h3>
      {faqs.map(faq).map(({ question, answer }) => (
        <Details key={question} summary={question} html={answer} />
      ))}
    </IntroductionWrapper>
  );
};

export default FAQDisplay;